import React from 'react';
import { Reveal } from './Reveal';
import { MagneticButton } from './MagneticButton';
import { useContent } from '../content/ContentProvider';
import '../styles/glass.css';

export const ContactForm: React.FC = () => {
  const { contact } = useContent();

  return (
    <section id="contact">
      <Reveal className="contact-wrap glass-strong">
        <div className="eyebrow">{contact.eyebrow}</div>
        <h2 style={{ marginTop: 18 }} dangerouslySetInnerHTML={{ __html: contact.headingHtml }} />
        <p className="lead" style={{ maxWidth: 600 }}>
          {contact.lead}
        </p>

        <div className="contact-row">
          {contact.buttons.map((btn) => (
            <MagneticButton
              key={btn.label}
              as="a"
              className={`btn-glass${btn.primary ? ' primary' : ''}`}
              href={btn.href}
              {...(btn.external ? { target: '_blank', rel: 'noreferrer' } : {})}
            >
              {btn.label}
            </MagneticButton>
          ))}
        </div>

        <div className="contact-meta">
          {contact.meta.map((m) => (
            <div key={m.label}>
              <div className="cm-label">{m.label}</div>
              <div className="cm-value">{m.value}</div>
            </div>
          ))}
        </div>
      </Reveal>
    </section>
  );
};
